import { Link } from 'react-router-dom'
import { Bell } from 'lucide-react'
import { useNotificationUnreadCountQuery } from '@/features/polish/polish-api'
import { Button } from '@/components/ui/button'

/**
 * Header bell icon with unread badge. Polls every 30s for live unread count.
 */
export function NotificationBell() {
  const { data } = useNotificationUnreadCountQuery(undefined, {
    pollingInterval: 30_000,
  })
  const count = data?.data.count ?? 0

  return (
    <Link to="/notifications" className="relative">
      <Button variant="ghost" size="icon" title="Notifications" aria-label={count > 0 ? `${count} unread notifications` : 'Notifications'}>
        <Bell className="h-4 w-4" />
      </Button>
      {count > 0 && (
        <span
          className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-medium text-destructive-foreground"
          aria-hidden="true"
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  )
}
